import { useCallback, useState } from 'react';

export const SUBMIT_STEP_COUNT = 4;

export type SubmitStep = 1 | 2 | 3 | 4;

export function useSubmitStepper(initialStep: SubmitStep = 1) {
  const [step, setStep] = useState<SubmitStep>(initialStep);
  const isFirst = step === 1;
  const isLast = step === SUBMIT_STEP_COUNT;

  const goNext = useCallback(() => {
    setStep((current) => Math.min(current + 1, SUBMIT_STEP_COUNT) as SubmitStep);
  }, []);

  const goBack = useCallback(() => {
    setStep((current) => Math.max(current - 1, 1) as SubmitStep);
  }, []);

  return { step, goNext, goBack, isFirst, isLast };
}
